import type { RouteRecordRaw } from 'vue-router'
import { TICKETS_ROUTES } from '@/router/routes.enum'

export const expressRescheduleRoutes: RouteRecordRaw[] = [
  {
    path: '/manage/reservation/:token',
    name: TICKETS_ROUTES.RESERVATIONS_EXPRESS_RESCHEDULE,
    component: () => import('@/tickets/modules/reservations/views/ExpressReschedule.view.vue')
  },
  {
    path: '/manage/reservation/:token/confirmation',
    name: TICKETS_ROUTES.RESERVATIONS_EXPRESS_RESCHEDULE_CONFIRMATION,
    component: () =>
      import('@/tickets/modules/reservations/views/ExpressRescheduleConfirmation.view.vue')
  }
]
